<script lang="ts">
  import { Heading, Wrapper, Paragraph } from './components';
  import type { UseFormattedProps } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;
</script>

<Wrapper style="background:var(--vlt-lp-background);">
  <div class="badges-section">
    <div>
      {#if properties?.heading}
        <Heading type="h2" css="color:var(--vlt-lp-text)">
          {@html properties.heading}
        </Heading>
      {/if}

      {#if properties?.description}
        <div class="preamble">
          <Paragraph css="color:var(--vlt-lp-text)">
            {@html properties.description}
          </Paragraph>
        </div>
      {/if}
    </div>

    {#if properties?.images?.length}
      <div class="images {properties?.images.length >= 3 ? 'fullWidth' : ''}">
        {#each properties.images as image}
          <div class="image">
            <img src={image} alt="badge" loading="lazy" />
          </div>
        {/each}
      </div>
    {/if}
  </div>
</Wrapper>

<style>
  .badges-section {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 0px 15px;
    grid-gap: 40px;
    text-align: center;
  }
  .images {
    display: grid;
    justify-content: center;
    align-items: center;
    text-align: center;
    grid-template-columns: repeat(auto-fit, minmax(125px, 1fr));
    grid-gap: 40px;
    max-width: 1200px;
    width: 100%;
    box-sizing: border-box;
  }
  img {
    width: 125px;
    height: 125px;
    object-fit: contain;
    margin: 0 auto;
  }
  .preamble {
    margin-top: 10px;
  }

  @media screen and (max-width: 768px) {
    .badges-section {
      text-align: center;
    }
    .preamble {
      margin-top: 20px;
    }
    .images {
      grid-gap: 40px;
    }
  }
  @media screen and (max-width: 660px) {
    .images {
      grid-template-columns: 1fr 1fr;
      grid-gap: 40px;
    }
  }
</style>
